/**
 * 处理系统返回按钮事件，以免按下返回键直接退出app
 */
export function handleSysBack() {
    document.addEventListener("plusready", () => {
        plus.key.addEventListener("backbutton", () => {
            let a = JSON.parse(window.localStorage.getItem("IS_COMPOENT"))
            if (a) {
                window.localStorage.setItem("IS_BREAK", true)
            } else if (location.hash === "#/") {
                console.log("quit")
                plus.runtime.quit();
            } else {
                history.back();
            }
        });
    })
}
